import { Group } from '@mantine/core';
import { UserRole } from '@repo/common/enums/UserRole';
import { Button, Title } from '@repo/foundations';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import {
	NavBarBreadcrumbWrapper,
	NavBarRightSideWrapper,
	NavBarWrapper,
} from '.';
import { usePolicyEnabled } from '../../../api';
import CreatePolicyModal from '../../../pages/PoliciesPage/components/CreatePolicyModal';
import { Guard } from '../../Guard/Guard';

const PoliciesPageNavBar = observer(() => {
	const [modalOpen, setModalOpen] = useState<boolean>(false);
	const policiesEnabled = usePolicyEnabled();
	if (!policiesEnabled) {
		return null;
	}

	return (
		<>
			<NavBarWrapper>
				<NavBarBreadcrumbWrapper>
					<Group>
						<Title
							order={1}
							size="sm"
							data-testid="policies-page-nav-bar-title"
						>
							Policies
						</Title>
					</Group>
				</NavBarBreadcrumbWrapper>
				<NavBarRightSideWrapper>
					<Guard
						v1AllowedRoles={[UserRole.ADMIN, UserRole.EDITOR]}
						v2Permission="Policies.Create"
					>
						<Button variant="primary" onClick={() => setModalOpen(true)}>
							Create policy
						</Button>
					</Guard>
				</NavBarRightSideWrapper>
			</NavBarWrapper>
			{modalOpen && <CreatePolicyModal onClose={() => setModalOpen(false)} />}
		</>
	);
});

PoliciesPageNavBar.displayName = 'PoliciesPageNavBar';
export default PoliciesPageNavBar;
